/**
 * Helper function to find duplicate items in an array
 * @param arr: an array
 * @returns {[]}: array of duplicate items
 */
export const arrayDuplicates = (arr) => {
  let sorted = arr.slice()
    .sort();
  let results = [];
  sorted.forEach((item, itemIndex) => {
    if (sorted[itemIndex + 1] === item) {
      results.push(item);
    }
  });
  return results;
};

export const groupWithImage = (group) => {
  const firstProductImages = (group.products[0] || {}).media?.images || [];
  const imageURL = firstProductImages.length ? firstProductImages[0].url : null;
  const image = imageURL ? imageURL.replace('<SIZE>', '145') : null;
  return {
    ...group,
    image
  };

};

/**
 * This hook gets the data from collection products and combines them based on their category.
 * It creates a "group" if there are more > 1 products of the same category.
 * Products with only 1 category all get grouped together into a "More Items" group
 * @param collection
 */
export const useGroupedProducts = ({ products }) => {
  const categories = (products || []).map((product) => product.info?.productDepartment);
  const multiProductGroups = [...new Set(arrayDuplicates(categories))];
  const singleProductGroups = categories.filter((category) => multiProductGroups.indexOf(category) === -1)
    .map((cat) => products.find((product) => product.info?.productDepartment === cat));
  let grouped = {
    collectionProducts: products,
    groups: []
  };
  if (!multiProductGroups.length || (multiProductGroups.length === 1 && !singleProductGroups.length)) {
    // if only one group we don't split by groups so just return the products
    return grouped;
  }
  const moreItemsGroup = {
    name: 'More Items',
    products: singleProductGroups
  };
  multiProductGroups.forEach((group) => {
    const productIndexes = categories.map((cat, catIndex) => {
      return cat === group ? catIndex : null;
    })
      .filter((cat) => cat !== null);
    const groupProducts = productIndexes.map((productIndex) => products[productIndex]);
    const productGroup = groupWithImage({
      name: group,
      products: groupProducts
    });
    grouped.groups.push(productGroup);
  });

  if (moreItemsGroup.products.length) {
    const group = groupWithImage(moreItemsGroup);
    grouped.groups.push(group);
  }

  return grouped;
};
